<template>
    <v-dialog v-model="dialog"
              max-width="1200px"
              @click-outside="dialog = false"
              content-class="pro-dialog">
        <v-card>
            <v-card-title class="d-flex justify-content-between">
                <h2 class="headline-title" style="font-size: 24px !important;">Modifier l'image principale</h2>

                <v-btn icon class="close-modal-icon" @click="dialog = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <div class="d-flex justify-start medias-box flex-wrap">
                    <v-card v-for="(media, index) in provider.medias" class="m-3 media-card"
                            v-if="(media.is_404 === undefined || !media.is_404) && media.is_image && index !== 0">
                        <v-img height="150px" width="250px" class="v-media"
                               :src="(media.thumbnail_url !== null) ? media.thumbnail_url : media.url">
                            <div class="media-logo"
                                 v-if="media.source !== undefined && media.source !== null && media.source.type !== 'APIDAE'">
                                <img :src="'/images/logo-' + media.source.type + '.jpg'" style="width: 30px;">
                            </div>
                        </v-img>

                        <v-card-text>
                            <div class="w-100 text-center">
                                <v-btn class="default-button text-none" @click="swapMedias(media)">Sélectionner
                                </v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapMutations, mapState} from "vuex"
export default {
    name: "SwapMediaModal",
    methods: {
        ...mapMutations('web_form', ['setSwitchMediaDialog']),
        swapMedias(mediaToSwap) {
            let indexToSwap = null

            this.provider.medias.forEach((media, index) => {
                if (media === mediaToSwap) {
                    indexToSwap = index
                }
            })

            let temp = JSON.parse(JSON.stringify(this.provider.medias[indexToSwap]))

            this.$set(this.provider.medias, indexToSwap, this.provider.medias[0])
            this.$set(this.provider.medias, 0, temp)

            this.setSwitchMediaDialog(false)
        },
    },
    computed: {
        ...mapState("web_form", ['switchMediaDialog', 'provider']),
        dialog :{
            get () {
                return this.switchMediaDialog
            },
            set (value) {
                this.setSwitchMediaDialog(value)
            }
        }
    }
}
</script>
